module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABT0lEQVQ4T53RMS/DQRgG8Oe5dtKYxaAfoHeD8AEoCbGIzd7JxiJEGITBwoDFyGCwMNgQicFkabz/NDGIsFkMkv/We+QaEqSa1I1393vvee9lCOEOQB+6W+8MITybWbkbF0KoJ/hiZgPdQO+9tWCe56FUKg1KoiTXrgjJSFIxxnsANy0IYALAEYA3SQ9/vF4mWXbO1WKMhwm+xhgnSc6RvDKzk3awUqmMk5x1zu1IOqf3fonkMAAPYNXMTgGkuPosQADRe18FcACgTjJLm63lvV9PMUk2Se4D+DpLBdYkPQKoZlm2nO5/hxsAGlmWHbeL6r1P7UyZ2UJbKKnhnJv+hS8k9XaEzWbzrlgsjqWvTziNCMCtpP6O8F9RST4BGCK5LWlUUk+hUDiLMa4AuAQwYmbzP3oMIdTSOCRtAVh0zl1LyiXNANgEkMa2a2Z7CX4AMwKkI01fZUcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persondata/personal_icon_fapiao.png
// module id = jIgU
// module chunks = 1